<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
  <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
    <mat-card-title>
      <div class="w-100 d-flex" style="background: #0f172a;">
        <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">{{ "Coffre à Tickets - Documents" | translate }}</span>
        <button class="m-l-auto" mat-icon-button (click)="matDialogRef.close();">
          <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
        </button>
      </div>
    </mat-card-title>
    <mat-card-title>
      <mat-form-field class="w-100" style="background: #0f172a;">
        <mat-icon matSuffix style="color: #1855d5; background: #0f172a; border-radius: 8px;">search</mat-icon>
        <input matInput [autocomplete]="'off'" [placeholder]="'Rechercher..'" class="cplaceholder" style="color: white;" #gridSearchInput>
      </mat-form-field> 
    </mat-card-title>
    <mat-card-subtitle style="background: #0f172a;color: white;" class="p-b-16">
      <div class="d-flex">
        <div class="d-flex flex">
          <div style="border-right: 2px solid #1855d5; margin-right: 15px;">
            <button mat-stroked-button (click)="showTicketPerimetreModal = true" style="color: gold; font-weight: 700; border: 1px solid; margin-right: 10px;">
              {{ "PERIMETRE" | translate }}
            </button>
          </div>
          <div class="d-grid">
            <span>Base de données embarquée </span>
            <span style="padding-top: 8px; font-size: 13px; color: #9b9b9f; font-weight: 600;">
                <span *ngIf="dataItems">{{ dataItems.length + " ticket(s)" }}</span>
                <ng-container *ngIf="pickedItems && pickedItems.length > 0">
                    -
                  <span>{{ pickedItems.length + " sélectionné(s)" }}</span>
                </ng-container>
            </span>
          </div>
        </div>
        <div class="m-l-auto">
          <button mat-stroked-button style="color: #f18b8b; font-weight: 700; border: 1px solid; margin-right: 10px;" (click)="onToggleAllNoneItemsEvent()">
            {{ "TOUS/AUCUN" | translate }}
          </button>
          <ng-container *ngIf="pickedItems && pickedItems.length > 0">
            <button mat-stroked-button [matMenuTriggerFor]="menu" style="color: #6a86f3; font-weight: 700; border: 1px solid; margin-right: 10px;">
              {{ "ACTIONS" | translate }}
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="doRunZVaultTicketDocumentChecksProcess_Session()">Contrôler les tickets</button>
            </mat-menu>
          </ng-container>
          <button mat-stroked-button (click)="cluGrid.saveAsExcel()" style="color: #1bee50; font-weight: 700; border: 1px solid; margin-right: 10px;">
            {{ "EXCEL" | translate }}
          </button>
          <button [matTooltip]="'Réajustement des colonnes'" (click)="cluGrid.autoFitColumns();" mat-stroked-button style="color: #ee1b6c; font-weight: 700; border: 1px solid; margin-right: 10px;">
            {{ "COLONNES" | translate }}
          </button>
        </div>
      </div>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content style="flex: 1;padding: 0;">
    <ng-container *ngIf="!loading && !!errorMessage; else grid">
        <div style="height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center">
            <div style="color: #444; font-weight : 400; text-align: center">{{ errorMessage }}</div>
        </div>
    </ng-container>
    <ng-template #grid>
        <kendo-grid #cluGrid [data]="gridView" [skip]="state.skip" [pageSize]="state.take" scrollable="virtual" [rowHeight]="36" [height]="420" [sortable]="{ mode : 'multiple' }" [sort]="state.sort" [rowHeight]="36" [height]="height" (dataStateChange)="onDataChange($event)"
                  [resizable]="true" [autoSize]="true" [columnMenu]="{ lock: true, stick: true, setColumnPosition: { expanded: true }, autoSizeColumn: true, autoSizeAllColumns: true }">
            <ng-container>
                <kendo-grid-column [width]="50" field="Z_ACTIONS" title="Actions">
                  <ng-template kendoGridHeaderTemplate let-column><span style="width: 50px"> {{ column.title }}</span></ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <button style="position: absolute; margin-top: -24px;" mat-icon-button [matMenuTriggerFor]="itemMenu" aria-label="MoreOptions">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #itemMenu="matMenu">
                      <button mat-menu-item (click)="doRunZVaultTicketDocumentChecksProcess_Session(dataItem)">Contrôler le ticket</button>
                      <button mat-menu-item [disabled]="dataItem.CHECK_STATUS == -1 || dataItem.CHECK_STATUS == 1" (click)="doSyncZVaultTicketDocumentItem_Session(dataItem)">Envoyer le ticket</button>
                    </mat-menu>
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="50" field="Z_ACTCHECK" title="Actions">
                  <ng-template kendoGridHeaderTemplate let-column><span style="width: 50px"> {{ column.title }}</span></ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <span style="position: absolute; margin-top: -20px;display: flex;">
                      <mat-checkbox [(ngModel)]="dataItem.Z_CHECKED" (change)="onToggleCheckboxItemEvent(dataItem)"></mat-checkbox>
                    </span>
                  </ng-template>
                </kendo-grid-column>
                <ng-container *ngFor="let column of columns">
                    <ng-container [ngSwitch]="column.pName">
                      <ng-container *ngSwitchCase="'MD_DOGID'">
                            <kendo-grid-column [width]="180" field="MD_DOGID" title="ID Ticket" [style]="{'font-weight': '600'}" [sticky]="true">
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span style="display:flex;align-items: center;">
                                    <i-tabler *ngIf="dataItem.CHECK_STATUS == -1" name="circle-filled" class="icon-16 d-flex" style="color: gray; align-items: center;" [matTooltip]="dataItem.CHECK_MESSAGE"></i-tabler>
                                    <i-tabler *ngIf="dataItem.CHECK_STATUS == 0" name="circle-filled" class="icon-16 d-flex" style="color: orangered; align-items: center;" [matTooltip]="dataItem.CHECK_MESSAGE"></i-tabler>
                                    <i-tabler *ngIf="dataItem.CHECK_STATUS == 1" name="circle-filled" class="icon-16 d-flex" style="color: green; align-items: center;" [matTooltip]="dataItem.CHECK_MESSAGE"></i-tabler>
                                    <i-tabler *ngIf="dataItem.CHECK_STATUS == 2" name="circle-filled" class="icon-16 d-flex" style="color: red; align-items: center;" [matTooltip]="dataItem.CHECK_MESSAGE"></i-tabler>
                                    <span style="padding-left: 4px;">{{ dataItem.MD_DOGID }}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_PIECE_INTERNAL'">
                            <kendo-grid-column [width]="180" field="DO_PIECE_INTERNAL" title="Ticket" [style]="{'font-weight': '600'}" [sticky]="true">
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span style="text-decoration: underline;cursor: pointer;display:flex;align-items: center;">
                                    <i-tabler *ngIf="dataItem.DO_SOLDETTC == 0" name="circle-check" class="icon-16 d-flex" style="color: #007d49; align-items: center;" [matTooltip]="'Ticket soldé'"></i-tabler>
                                    <i-tabler *ngIf="dataItem.DO_SOLDETTC != 0" name="circle-check" class="icon-16 d-flex" style="color: #9f1b4c; align-items: center;" [matTooltip]="'Ticket non soldé'"></i-tabler>
                                    <span style="padding-left: 4px;" [style.opacity]="dataItem.NB_LIGNE > 0 ? 1 : 0.4">{{ dataItem.DO_PIECE_INTERNAL }}</span>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_DATE'">
                            <kendo-grid-column [width]="150" field="DO_DATE" title="Date" [style]="{'font-weight': '600'}"> 
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span>{{ dataItem.DO_DATE | date : 'dd/MM/yyyy HH:mm:ss' }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_TYPE_OP'">
                            <kendo-grid-column [width]="150" field="DO_TYPE_OP" title="Type op.">
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span class="d-flex">
                                    <span *ngIf="dataItem.DO_TYPE_OP != 'RETOUR' && dataItem.DO_TYPE_OP != 'RETOUR_TEST'" style="color: #1c47c5; font-weight: 700; font-size: 11px;">{{ dataItem.DO_TYPE_OP | translate }}</span>
                                    <span *ngIf="dataItem.DO_TYPE_OP == 'RETOUR' || dataItem.DO_TYPE_OP == 'RETOUR_TEST'" style="color: #d70f0f; font-weight: 700; font-size: 11px;">{{ "RETOUR " | translate }}</span>
                                    <i-tabler *ngIf="dataItem.DO_SIGNATURE_OFFLINE == 1" name="wifi-off" class="icon-16 d-flex" style="color: #b1b1b1; align-items: center;"></i-tabler>
                                    </span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_TOTALHT'">
                            <kendo-grid-column [width]="150" field="DO_TOTALHT" title="Total HT" [style]="{'text-align': 'end', 'font-weight': '600'}"> 
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span>{{ dataItem.DO_TOTALHT | number }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_TOTALTTC'">
                            <kendo-grid-column [width]="150" field="DO_TOTALTTC" title="Total TTC" [style]="{'text-align': 'end', 'font-weight': '600'}"> 
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span>{{ dataItem.DO_TOTALTTC | number }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_MONTANTREGLE'">
                            <kendo-grid-column [width]="150" field="DO_MONTANTREGLE" title="Total RG" [style]="{'text-align': 'end', 'font-weight': '600'}"> 
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span>{{ dataItem.DO_MONTANTREGLE | number }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchCase="'DO_SOLDETTC'">
                            <kendo-grid-column [width]="150" field="DO_SOLDETTC" title="Solde" [style]="{'text-align': 'end', 'font-weight': '600'}"> 
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                                <ng-template kendoGridCellTemplate let-dataItem>
                                    <span>{{ dataItem.DO_SOLDETTC | number }}</span>
                                </ng-template>
                            </kendo-grid-column>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <kendo-grid-column [width]="100" [field]="column.pName" [title]="column.title" [hidden]="column.hidden">
                                <ng-template kendoGridHeaderTemplate let-column><span style="width: 100px"> {{ column.title | translate }}</span></ng-template>
                            </kendo-grid-column>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
            <kendo-grid-excel fileName="CaurisLinkUp_ZTicketVault.xlsx" [fetchData]="doGridFetchAllData"></kendo-grid-excel>
        </kendo-grid>
    </ng-template>
  </mat-card-content>
  <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
    <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
      <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="matDialogRef.close();">
        {{ "FERMER" | translate }}
      </button>
    </div>
  </mat-card-actions>
</mat-card>

<kendo-dialog title="Périmètre de sélection" *ngIf="showTicketPerimetreModal" [width]="520" [height]="800">

  <div class="flex flex-col gap-16">
    <!-- 🔹 Sessions de caisse -->
    <div>
      <label class="font-semibold text-sm mb-1 block">
        Sessions de caisse
      </label>

      <kendo-multiselect [data]="startupInfos.CAISSE_SESSION_ITEMS" [(ngModel)]="searchTicketPerimetre.CAISSE_SESSION_ITEMS" placeholder="Toutes les sessions" [autoClose]="false" > </kendo-multiselect>
    </div>

    <!-- 🔹 Filtre période -->
    <div class="border-t pt-3">

      <kendo-switch [(ngModel)]="searchTicketPerimetre.FLT_PERIOD_ENABLED" onLabel="Oui" offLabel="Non" ></kendo-switch>

      <span class="ml-2 font-semibold"> Filtrer par période </span>

      <div class="grid grid-cols-2 gap-16 mt-3" *ngIf="searchTicketPerimetre.FLT_PERIOD_ENABLED">

        <kendo-datepicker [(ngModel)]="searchTicketPerimetre.BORNE_INF" placeholder="Date début" ></kendo-datepicker>

        <kendo-datepicker [(ngModel)]="searchTicketPerimetre.BORNE_SUP" placeholder="Date fin" ></kendo-datepicker>
      </div>

    </div>

  </div>

  <!-- 🔹 Actions -->
  <kendo-dialog-actions align="end">
    <button kendoButton (click)="showTicketPerimetreModal = false">
      FERMER
    </button>

    <button kendoButton themeColor="primary" (click)="doLoadDbDataItemsAction_ZTicketVault(); showTicketPerimetreModal = false;">
      Appliquer
    </button>
  </kendo-dialog-actions>

</kendo-dialog>
